import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Pagination } from "swiper/modules"
import { useRef } from "react"
import { motion, useInView } from "framer-motion"
import { Link } from "react-router-dom"

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"


const planos = [
    {
        titulo: "Plano Casa 6x20",
        area: "120 m²",
        hab: "2 habitaciones",
        banos: "1 baño",
        precio: "S/ 80",
        img: "https://thumbs.dreamstime.com/b/plano-de-piso-arquitect%C3%B3nico-ilustraci%C3%B3n-una-disposici%C3%B3n-la-casa-moderno-edificio-con-habitaciones-y-muebles-dise%C3%B1o-un-plan-408294998.jpg",
        link: "/planos"
    },
    {
        titulo: "Plano Casa 8x20",
        area: "160 m²",
        hab: "3 habitaciones",
        banos: "2 baños",
        precio: "S/ 120",
        img: "https://planosycasas.net/wp-content/uploads/2013/06/Distribuci%C3%B3n-de-ambientes-en-departamento.jpg",
        link: "/planos"
    },
    {
        titulo: "Plano Casa 10x20",
        area: "200 m²",
        hab: "3 habitaciones",
        banos: "2 baños",
        precio: "S/ 150",
        img: "https://i.pinimg.com/originals/95/5b/3b/955b3b62df79f49b8eeeacf2f85e0d15.jpg",
        link: "/planos"
    },
    {
        titulo: "Plano Casa 10x25",
        area: "250 m²",
        hab: "4 habitaciones",
        banos: "3 baños",
        precio: "S/ 180",
        img: "https://i.pinimg.com/originals/cb/19/fd/cb19fd4ffaece62d6455953f9d32082d.jpg",
        link: "/planos"
    },
    {
        titulo: "Plano Casa 12x25",
        area: "300 m²",
        hab: "4 habitaciones",
        banos: "3 baños",
        precio: "S/ 200",
        img: "https://i.pinimg.com/474x/dd/91/75/dd91750f89bb0111406525df783cd3b3.jpg",
        link: "/planos"
    }
]

export default function PlanosDestacados() {
    const containerRef = useRef(null);
    const isInView = useInView(containerRef, { once: true, margin: "-100px" });

    return (
        <section
            ref={containerRef}
            id="planos"
            className="relative bg-[#FAFAFA] py-24 sm:py-32 overflow-x-hidden"
        >
            <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />

            {/* CONTENEDOR DE ALINEACIÓN (Para Título y Botón) */}
            <div className="max-w-7xl mx-auto px-6 lg:px-8">

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={isInView ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.6 }}
                    className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16"
                >
                    <div className="max-w-2xl">
                        <span className="text-[#F26B1D] font-bold tracking-[0.2em] text-xs uppercase mb-3 block">
                            Arquitectura & Ingeniería
                        </span>
                        <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-900 leading-tight">
                            Planos <span className="text-[#F26B1D]">Disponibles</span>
                        </h2>
                        <p className="text-gray-500 mt-5 text-lg leading-relaxed">
                            Planos listos para construir. Diseños que se adaptan a tu terreno.
                        </p>
                    </div>

                    <div className="flex gap-4">
                        <button className="swiper-prev-planos w-12 h-12 rounded-full border border-gray-200 flex items-center justify-center hover:bg-white hover:text-[#F26B1D] transition-all shadow-sm">
                            ←
                        </button>
                        <button className="swiper-next-planos w-12 h-12 rounded-full bg-gray-900 text-white flex items-center justify-center hover:bg-[#F26B1D] transition-all shadow-lg">
                            →
                        </button>
                    </div>
                </motion.div>

                {/* CONTENEDOR DEL CARRUSEL: Control de ancho (92% - 96%) */}
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    animate={isInView ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.8, delay: 0.2 }}
                    className="w-[98%] lg:w-[100%] mx-auto"
                >
                    <Swiper
                        modules={[Navigation, Pagination]}
                        className="pb-24 pt-16 px-2 [&_.swiper-pagination]:!bottom-0"
                        navigation={{
                            nextEl: ".swiper-next-planos",
                            prevEl: ".swiper-prev-planos"
                        }}
                        pagination={{ clickable: true, dynamicBullets: true }}
                        spaceBetween={28}
                        breakpoints={{
                            0: { slidesPerView: 1.15 },
                            640: { slidesPerView: 2.2 },
                            1024: { slidesPerView: 3 },
                            1280: { slidesPerView: 4 }
                        }}
                    >
                        {planos.map((plano, index) => (
                            <SwiperSlide key={index} className="h-auto py-8">
                                <motion.div
                                    whileHover={{ y: -12 }}
                                    className="group bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-500 h-full flex flex-col"
                                >
                                    {/* Imagen: altura fija para que todas sean iguales */}
                                    <div className="relative h-48 overflow-hidden flex-shrink-0">
                                        <img
                                            src={plano.img}
                                            alt={plano.titulo}
                                            className="w-full h-full object-cover transition duration-700 group-hover:scale-110"
                                        />
                                        <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm text-gray-900 text-[10px] uppercase px-3 py-1.5 rounded-lg font-bold shadow-sm">
                                            {plano.area}
                                        </div>
                                    </div>

                                    <div className="p-6 flex flex-col flex-grow">

                                        {/* ✅ Título con altura mínima fija: evita que cards crezcan por títulos largos */}
                                        <h3 className="text-xl font-bold text-gray-900 group-hover:text-[#F26B1D] transition-colors min-h-[56px] line-clamp-2">
                                            {plano.titulo}
                                        </h3>

                                        {/* ✅ Info de habitaciones: altura fija */}
                                        <div className="flex items-center gap-3 mt-3 text-gray-500 text-xs h-5">
                                            <span>🛏️ {plano.hab}</span>
                                            <span className="w-1 h-1 bg-gray-300 rounded-full" />
                                            <span>🚿 {plano.banos}</span>
                                        </div>

                                        {/* ✅ Divider + precio + botón siempre al fondo */}
                                        <div className="mt-auto pt-5 border-t border-gray-100 flex items-center justify-between">
                                            <div>
                                                <p className="text-[10px] text-gray-400 uppercase font-bold tracking-wider">Inversión</p>
                                                <p className="text-2xl font-black text-gray-900">{plano.precio}</p>
                                            </div>
                                            <Link
                                                to={plano.link}
                                                className="h-10 w-10 bg-gray-50 rounded-full flex items-center justify-center group-hover:bg-[#F26B1D] group-hover:text-white transition-all duration-300"
                                            >
                                                →
                                            </Link>
                                        </div>
                                    </div>
                                </motion.div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </motion.div>

                {/* BOTÓN CTA CENTRADO */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    className="mt-10 flex justify-center px-6"
                >
                    <Link
                        to="/planos"
                        className="
      inline-flex items-center justify-center 
      px-6 py-4 md:px-10 
      text-sm md:text-base font-bold 
      rounded-full shadow-lg text-white bg-gray-900 
      hover:bg-[#F26B1D] transition-all duration-300 
      transform hover:scale-105 active:scale-95
      w-full md:w-auto max-w-xs md:max-w-none
    "
                    >
                        {/* Texto dinámico */}
                        <span className="md:hidden">Explorar galería</span>
                        <span className="hidden md:inline">Explorar galería completa</span>

                        <motion.span
                            animate={{ x: [0, 5, 0] }}
                            transition={{ repeat: Infinity, duration: 1.5 }}
                            className="ml-2"
                        >
                            →
                        </motion.span>
                    </Link>
                </motion.div>
            </div>
        </section>
    )
}